import ShiningStars from 'components/logistics/stats/shining_stars';
import React, { useEffect, useState } from 'react';
import { LogisticsRidersType } from './logistics-stats-page-four';
import { apiService } from 'utils/api';
import { SocketIOConnection } from 'utils/socket_client';

const LogisticsStatsPageFive = () => {
  const [data, setData] = useState<LogisticsRidersType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getTopRidersWeekly = async () => {
    try {
      const res = await apiService.post('logistics/team-weekly-performance', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      const riders = res.data.data;
      riders.sort((a: LogisticsRidersType, b: LogisticsRidersType) => {
        return a.duration - b.duration;
      });
      setData(riders);
    } catch (err: any) {
      console.log(err);
    }
  };
  const connectSocket = async () => {
    const conn = await SocketIOConnection.getConnection();
    conn.onReconnect(async () => {
      conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
      const res: any = await getTopRidersWeekly();
      setData(res);
    });

    const roomName = 'logistics-weekly-performance-stat';
    conn.addEventListener(roomName, 'update', (data: any) => {
      const riders = data;
      riders.sort((a: LogisticsRidersType, b: LogisticsRidersType) => {
        return a.duration - b.duration;
      });
      setData(riders);
    });
    conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
  };
  useEffect(() => {
    setLoading(true);
    getTopRidersWeekly();
    setLoading(false);
    connectSocket();
  }, []);
  return (
    <ShiningStars title='Shining stars by duration ‍⚡️' data={data} loading={loading} duration />
  );
};

export default LogisticsStatsPageFive;
